import React, { useId } from 'react';
import { LockedGameArtwork } from './LockedGameArtwork';
import { UpcomingGameArtwork } from './UpcomingGameArtwork';
import { EngravedVEmblem } from './EngravedVEmblem';

// Original vector game illustrations, sized to keep all key objects inside the tile.
export const GameArtwork = ({ game, preserveAspectRatio, preview = false }) => {
  const id = useId().replace(/:/g, '');
  const keno = game === 'keno';
  if (['plinko', 'coinflip', 'roulette', 'baccarat'].includes(game)) return <UpcomingGameArtwork game={game} preserveAspectRatio={preserveAspectRatio} />;
  if (!keno && game !== 'blackjack') return <LockedGameArtwork game={game} preserveAspectRatio={preserveAspectRatio} preview={preview} />;
  return (
    <svg viewBox="0 0 300 400" preserveAspectRatio={preserveAspectRatio} fill="none" aria-hidden="true" focusable="false" className="originals-artwork">
      <defs>
        <linearGradient id={`${id}-bg`} x1="25" y1="0" x2="275" y2="400" gradientUnits="userSpaceOnUse">
          <stop stopColor={keno ? '#136be3' : '#ed3055'} /><stop offset="1" stopColor={keno ? '#03c2b5' : '#98113b'} />
        </linearGradient>
        <linearGradient id={`${id}-tile`} x1="0" y1="0" x2="70" y2="80" gradientUnits="userSpaceOnUse">
          <stop stopColor="#75ffb5" /><stop offset="1" stopColor="#00ce78" />
        </linearGradient>
        <linearGradient id={`${id}-card`} x1="0" y1="0" x2="120" y2="165" gradientUnits="userSpaceOnUse">
          <stop stopColor="#ffffff" /><stop offset="1" stopColor="#d9e4f1" />
        </linearGradient>
        <linearGradient id={`${id}-shade`} x1="150" y1="245" x2="150" y2="400" gradientUnits="userSpaceOnUse">
          <stop stopColor={keno ? '#00435e' : '#550e2d'} stopOpacity="0" /><stop offset="1" stopColor={keno ? '#00435e' : '#550e2d'} stopOpacity=".7" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}-bg)`} d="M0 0h300v400H0z" />
      {keno ? <>
        <path d="M0 92 300 20M0 189 300 117M0 286 300 214M0 383 300 311M42 0l68 400M145 0l68 400M248 0l52 310" stroke="#b2efff" strokeOpacity=".13" strokeWidth="3" />
        <g fontFamily="Sora, sans-serif" fontSize="25" fontWeight="700" fill="#c3faff" opacity=".35" textAnchor="middle">
          <text x="48" y="127" transform="rotate(-12 48 127)">8</text><text x="246" y="184" transform="rotate(-12 246 184)">21</text>
          <text x="100" y="281" transform="rotate(-12 100 281)">32</text><text x="268" y="283" transform="rotate(-12 268 283)">40</text>
        </g>
        <g className="preview-keno"><g transform="translate(75 103) rotate(-14 65 72)">
          <rect x="0" y="9" width="134" height="147" rx="18" fill="#005471" />
          <rect width="134" height="147" rx="18" fill={`url(#${id}-tile)`} />
          <rect x="8" y="8" width="118" height="129" rx="13" stroke="#c5ffe2" strokeOpacity=".55" strokeWidth="2" />
          <text x="67" y="108" textAnchor="middle" fill="#075d3d" fontFamily="Bricolage Grotesque, sans-serif" fontSize="87" fontWeight="800">7</text>
        </g></g>
        <g transform="translate(201 61) rotate(10 20 22)">
          <path d="M0 14 13 0h31l13 14-28 37Z" fill="#f1fff5" /><path d="m0 14 29 37-13-37ZM57 14 29 51l13-37Z" fill="#6bffa2" />
          <path d="M13 0h31L29 14Z" fill="#b8ffd9" /><path d="m16 14 13 37 13-37Z" fill="#d5ffe7" />
        </g>
        <path d="m59 197 4 11 11 4-11 4-4 11-4-11-11-4 11-4Z" fill="#dcfff6" />
      </> : <>
        <path d="M195 0h60L88 400H28Z" fill="#ff7184" opacity=".16" />
        <path d="m276 63 11 18-11 18-11-18Zm-224 174 10 16-10 16-10-16Z" fill="#ffb7c5" opacity=".6" />
        <g className="preview-blackjack-back"><g transform="translate(129 66) rotate(17 57 85)">
          <rect x="0" y="7" width="115" height="163" rx="10" fill="#720d31" fillOpacity=".5" />
          <rect width="115" height="163" rx="10" fill="#173752" stroke="#b6dfec" strokeWidth="3" />
          <rect x="8" y="8" width="99" height="147" rx="6" stroke="#5a8ea5" />
          <EngravedVEmblem id={id} x={35} y={52} width={48} height={60} />
        </g></g>
        <g className="preview-blackjack-front"><g transform="translate(51 96) rotate(-15 58 81)">
          <rect x="0" y="7" width="117" height="165" rx="10" fill="#720d31" fillOpacity=".45" />
          <rect width="117" height="165" rx="10" fill={`url(#${id}-card)`} />
          <text x="13" y="34" fill="#182936" fontFamily="Bricolage Grotesque, sans-serif" fontSize="30" fontWeight="800">A</text>
          <path d="M59 49C49 64 33 70 33 87c0 13 17 17 25 7l-6 20h16l-7-20c10 11 25 6 25-7 0-17-17-23-27-38Z" fill="#182936" />
          <text x="13" y="34" transform="rotate(180 58.5 82.5)" fill="#182936" fontFamily="Bricolage Grotesque, sans-serif" fontSize="30" fontWeight="800">A</text>
        </g></g>
        <g transform="translate(208 238) rotate(-12)">
          <ellipse cy="9" rx="31" ry="27" fill="#a96910" /><ellipse rx="31" ry="27" fill="#ffcf61" stroke="#ffe9aa" strokeWidth="2" />
          <ellipse rx="23" ry="19" stroke="#ad7422" strokeDasharray="7 5" strokeWidth="4" />
          <path d="m-13-10 9 22h8l9-22H5L0 3l-5-13Z" fill="#77521b" />
        </g>
      </>}
      <path fill={`url(#${id}-shade)`} d="M0 245h300v155H0z" />
    </svg>
  );
};